import { Injectable } from "@angular/core";
import { HttpClient, HttpResponse, HttpHeaders } from "@angular/common/http";
//Grab everything with import 'rxjs/Rx';
import { Observable, Observer, Subject, forkJoin, of } from "rxjs";
import { map, catchError, share, publishReplay } from "rxjs/operators";

import { environment } from "../../../../environments/environment";

import {
  PaymentService, LineItem, ProductSubType,
  PaymentSummary,
  PaymentDetails,
  PaymentUIConfiguration,
  CustType,
  GPOrgCode,
  OrderSource,
  OrderTypeCode,
  OrderDetails,
  OrgCode,
  CardType
} from "@acepteam/payment";
import * as globalsvc from "@acepteam/globalspack";
import { MemberAppData } from "../../../shared/models";
import { GraduatingResidentOption } from "src/app/shared/models/my-account-data.models";
import { MemberAppDataService } from "../../services";
import { DataService } from "src/app/core/services";

declare var $: any;

@Injectable({
  providedIn: "root"
})
export class CheckoutService {
  clientPingResponseRxd$ = new Subject<boolean>();
  headers: HttpHeaders;
  clientsWithCallBackApis = [];
  isClientCallbackAvailable: boolean = false;
  constructor(
    private http: HttpClient,
    private globaldomops: globalsvc.GlobalDomOpsService,
    private globaldataops: globalsvc.GlobalDataOpsService,
    private ssosvc: globalsvc.AcepSSOService,
    private datasvc: DataService,
    private commonopssvc: globalsvc.CommonOperationsService,
    private paymentservice: PaymentService,
    private memberAppDataService: MemberAppDataService,
  ) {

    //DEV ONLY - MB 3/19/2024 -- COMMENT IT AFTER DONE
    if (window.location.href.indexOf('localhost') > -1) {
      this.paymentservice.paymentWebServicePath = 'http://localhost/OrderWS/api/2015/orders/';
    }

  }

  public getGraduatingResidentItems(): Observable<GraduatingResidentOption[]> {
    let summary_GradRes_Monthly = this.memberAppDataService.getContentSnippet(`MEMBERAPPLICATION_GRADUATINGRESIDENTS_MONTHLY`);
    let summary_GradRes_Annual = this.memberAppDataService.getContentSnippet(`MEMBERAPPLICATION_GRADUATINGRESIDENTS_ANNUAL`);


    let opt_Monthly: GraduatingResidentOption = { Title: 'Monthly', Rate: 'RegYR123', Summary: summary_GradRes_Monthly, OrderDetails: null, res: null };

    let opt_Annual: GraduatingResidentOption = { Title: 'Annual', Rate: 'RegYR1', Summary: summary_GradRes_Annual, OrderDetails: null, res: null };

    let obs1: Observable<any> = this.CalculateOrder(this.memberAppDataService.memberAppData, opt_Monthly.Rate, false);
    let obs2: Observable<any> = this.CalculateOrder(this.memberAppDataService.memberAppData, opt_Annual.Rate, false);

    let GRData$: Observable<GraduatingResidentOption[]> | Observable<any> | any = forkJoin(
      obs1,
      obs2
    ).pipe(
      map((res: any) => {

        //No installments
        res[0].orderTypeInfo.allowInstalments = false;
        res[1].orderTypeInfo.allowInstalments = false;

        //SHOW PromoCodes
        res[0].orderTypeInfo.allowPromoCode = false;
        res[1].orderTypeInfo.allowPromoCode = true;

        //LOCK AUTORENEWAL
        res[0].orderTypeInfo.autoRenewalState = 3;
        res[1].orderTypeInfo.autoRenewalState = 1;


        let orderdetails_Monthly: OrderDetails = this.MapResToOrderDetails(res[0]);
        let orderdetails_Annual: OrderDetails = this.MapResToOrderDetails(res[1]);

        opt_Monthly.res = res[0];
        opt_Monthly.OrderDetails = orderdetails_Monthly;
        //opt_Monthly.Price = orderdetails_Monthly.TotalAmount;

        opt_Annual.res = res[1];
        opt_Annual.OrderDetails = orderdetails_Annual;
        //opt_Annual.Price = orderdetails_Annual.TotalAmount;

        return [opt_Monthly, opt_Annual];

      }),
      share()
    );


    return GRData$;
  }

  public CalculateOrder(memberAppData: MemberAppData, UOM_Override: string = '', applyResponse: boolean = true) {
    let orderdetails: OrderDetails = new OrderDetails();

    orderdetails = {
      OrderId: "",
      CustomerType: CustType[CustType.Contact],
      TotalAmount: 0,
      TotalDiscount: 0,
      AcepId: this.ssosvc.acepid,
      AccountNumber: "",
      ClientIPAddress: "",
      ClientID: this.ssosvc.acepid,
      Description: "",
      GPOrgCode: GPOrgCode.ACEP,
      OrderSource: OrderSource.Web,
      OrderTypeCode: OrderTypeCode[OrderTypeCode.MembershipIndividual],
      OrgCode: OrgCode.ACEP,
      PriceListName: "MEMBERSHIP",
      PromoCode: this.commonopssvc.getQueryString('campaign'), //campaign codes
      PromoCodeValid: null,
      PromoCodeMetadata: null,
      PaymentInformation: new PaymentDetails(),
      orderLineItems: this.CreateLineItemsToSendToCalculateOrder(memberAppData),
      TransactionId: "",
      AccountDetails: null,
      MemberIds: "",
      GroupOrder: "",
      IsTrialMembership: null,
      FutureMemberRate_Override: UOM_Override,
      CCEmail: "",

      TotalShipping: null,
      AllowShipping: null,
      ShippingAddress: null,
      ExisitngAddresses: null
    };

    if (UOM_Override == 'RegYR123') {
      //if IsRegYR123, then promo code should be the primary chapter code as that is also set as the promo code to
      //discount the national dues (25$ originally) - MB 3/
      let promo = orderdetails.orderLineItems.find(a => a.IsPrimary)?.ProductNumber;
      orderdetails.PromoCode = promo;
    }

    if (orderdetails.PromoCode == null) {
      orderdetails.PromoCode = "";
    }

    return this.http
      .post(
        this.paymentservice.paymentWebServicePath + "CalculateOrder",
        JSON.stringify(orderdetails),
        { headers: this.paymentservice.paymentheaders }
      )
      .pipe(
        //applyResponse is false when we aer firing multiple Calculate order calls on page load to find out the order ttoals in each case regadless of user selection
        //MB 3/19/2024
        map((res: HttpResponse<any>) => this.MapOrderDetailsFromCalculateOrderResponse(res, applyResponse)
        )
      );
  }

  MapOrderDetailsFromCalculateOrderResponse(res: any, applyResponse: boolean) {
    let orderdetails: OrderDetails = this.MapResToOrderDetails(res);
    if (applyResponse) {
      this.paymentservice.orderdetails = orderdetails;

    }
    return res;

  }

  MapResToOrderDetails(res: any): OrderDetails {

    let orderdetails: OrderDetails = {
      OrderId: "",
      CustomerType: CustType[CustType.Contact],
      TotalAmount: res.totalAmount,
      TotalDiscount: res.totalDiscount,
      AcepId: this.ssosvc.acepid,
      AccountNumber: "",
      ClientIPAddress: "",
      ClientID: this.ssosvc.acepid,
      Description: "",
      GPOrgCode: GPOrgCode.ACEP,
      OrderSource: OrderSource.Web,
      OrderTypeCode: OrderTypeCode[OrderTypeCode.MembershipIndividual],
      OrgCode: OrgCode.ACEP,
      PriceListName: "MEMBERSHIP",
      PromoCode: res.promoCode,
      PaymentInformation: new PaymentDetails(),
      orderLineItems: this.MapLineItems(res.orderLineItems),
      TransactionId: "",
      AccountDetails: null,
      MemberIds: "",
      GroupOrder: "",
      PromoCodeValid: res.promoCodeValid,
      IsTrialMembership: res.promoCodeValid && res.isTrialMembership,
      PromoCodeMetadata: res.promoCodeMetadata,
      FutureMemberRate_Override: "",
      CCEmail: "",

      TotalShipping: res.totalShipping,
      AllowShipping: res.allowShipping,
      ShippingAddress: res.shippingAddress,
      ExisitngAddresses: res.exisitngAddresses

    };

    return orderdetails;
  }

  MapLineItems(oli: any): LineItem[] {
    let lineitems: LineItem[] = [];
    lineitems = oli.map(li => {
      return {
        ExtendedAmount: li.extendedAmount,
        ProductNumber: li.productNumber,
        ProductName: li.productName,
        Quantity: li.quantity,
        UnitPrice: parseFloat(li.unitPrice).toFixed(2), // li.unitPrice,
        UOM: li.uom,
        OverridePrice: li.overridePrice,
        IsPrimary: li.isPrimary,
        ProductSubType: li.productSubType,
        AccountId: li.accountId,
        Modifiable: li.modifiable,
        Selected: true //
      };
    });

    return lineitems;
  }


  CreateLineItemsToSendToCalculateOrder(memberAppData: MemberAppData): LineItem[] {

    let lineItems: LineItem[] = [];

    if (!memberAppData.profile.IsInternational) {
      let chapters = memberAppData.chapterDetails.chapters.filter(c => c.selected);

      for (let index = 0; index < chapters.length; index++) {
        let li = new LineItem();
        li.ProductSubType = ProductSubType.ChapterDues;
        li.AccountId = chapters[index].id;
        li.ProductNumber = chapters[index].code;
        li.ProductName = chapters[index].name;
        li.IsPrimary = chapters[index].isPrimary;

        lineItems.push(li);
      }
    }



    let sections = memberAppData.sectionDetails.sections.filter(c => c.selected);

    for (let index = 0; index < sections.length; index++) {
      let li = new LineItem();
      li.ProductSubType = ProductSubType.SECT;
      li.AccountId = sections[index].id;
      li.ProductNumber = sections[index].code;
      li.ProductName = sections[index].name;

      lineItems.push(li);
    }


    return lineItems;

  }




  //   public SynchClientPayloadToACEPPayload(pJson: any) {
  //     let p = JSON.parse(pJson);
  //     let paymentuiconfig: PaymentUIConfiguration = new PaymentUIConfiguration();
  //     paymentuiconfig.PRMOCODELABEL = "Campaign Code"
  //     paymentuiconfig.CLIENT_GOBACKURL = p.backUrl;
  //     paymentuiconfig.CLIENT_RECEIPTURL = p.returnUrl;
  //     paymentuiconfig.CLIENT_CONFIRMURL = !!p.confirmUrl ? p.confirmUrl : "";

  //     paymentuiconfig.VENDOR = p.brand;
  //     paymentuiconfig.LOCKPROMOCODE = !!p.lockPromoCode
  //       ? p.lockPromoCode
  //       : paymentuiconfig.LOCKPROMOCODE;
  //     paymentuiconfig.LOCKAUTORENEWAL = !!p.lockAutoRenewal
  //       ? p.lockAutoRenewal
  //       : paymentuiconfig.LOCKAUTORENEWAL;
  //     paymentuiconfig.AUTORENEWAL_DESCRIPTION = !!p.autoRenewalDescription
  //       ? p.autoRenewalDescription
  //       : "";

  //     let orderdetails: OrderDetails = new OrderDetails();
  //     orderdetails.PaymentInformation = new PaymentDetails();
  //     orderdetails.AccountNumber = orderdetails.AcepId = p.customerNumber;
  //     if (this.ssosvc.acepid == p.customerNumber) {
  //       //dont pass account number if its a customer
  //       orderdetails.AccountNumber = "";
  //     } else {
  //       //Account
  //       orderdetails.CustomerType = CustType[CustType.Account];
  //     }

  //     orderdetails.OrderTypeCode = p.orderType;
  //     orderdetails.GPOrgCode = +GPOrgCode[p.gpOrganization];
  //     orderdetails.OrgCode = +OrgCode[p.organization];
  //     orderdetails.PriceListName = p.priceList;

  //     //override line item price only if price is not passed and price is not passed as 0
  //     p.lineItems.forEach(function(li) {
  //       li.OverridePrice =
  //         !!li.UnitPrice || parseFloat(li.UnitPrice) == 0 ? false : true;
  //     });

  //     orderdetails.orderLineItems = p.lineItems;
  //     orderdetails.PromoCode = !!p.promoCode ? p.promoCode : "";
  //     orderdetails.Description = !!p.description ? p.description : "";
  //     orderdetails.TransactionId = p.transactionId;
  //     orderdetails.ClientIPAddress = p.clientIpAddress;
  //     orderdetails.ClientID = paymentuiconfig.VENDOR + "-" + this.ssosvc.acepid;
  //     orderdetails.orderLineItems.forEach(function(li) {
  //       li.ExtendedAmount = "";
  //       li.ProductName = !!li.ProductName ? li.ProductName : "";
  //       li.Quantity = !!li.Quantity ? li.Quantity : "1";
  //       li.UnitPrice = !!li.UnitPrice ? li.UnitPrice : "0";
  //       li.UOM = !!li.UOM ? li.UOM : "EACH";
  //       li.OverridePrice = li.OverridePrice;
  //     });

  //     this.paymentservice.paymentuiconfig = paymentuiconfig;

  //    this.paymentservice.orderdetails = orderdetails;

  //     this.isClientCallbackAvailable =
  //       this.clientsWithCallBackApis.indexOf(
  //         paymentuiconfig.VENDOR.toUpperCase()
  //       ) > -1 || paymentuiconfig.CLIENT_CONFIRMURL != "";
  //     //this.UpdatePreferencesBasedOnOrderType(orderdetails.OrderTypeCode);
  //   }

  //   public AnalyzePaymentConfiguration(pJson: any) {
  //     if (pJson != null) {
  //       this.SynchClientPayloadToACEPPayload(pJson);

  //       this.paymentservice.orderdetails.AcepId = this.ssosvc.acepid;
  //       this.paymentservice.GetTotalPriceFromLineItems();
  //     }
  //   }

  public AddPaymentUIConfiguration() {
    // let paymentuiconfig: PaymentUIConfiguration = new PaymentUIConfiguration();
    // paymentuiconfig.PRMOCODELABEL = "Campaign Code";
    // paymentuiconfig.SHOWAMOUNT = true;
    // this.paymentservice.paymentuiconfig = paymentuiconfig;
    // this.paymentservice.orderdetails.AcepId = this.ssosvc.acepid;

    this.paymentservice.paymentuiconfig.VENDOR = `${this.globaldataops.ORG} Membership`;
    this.paymentservice.paymentuiconfig.ACH_DESCRIPTION =
      this.memberAppDataService.getContentSnippet(`ACH Payment Header`);
  }

  private initHeaders() {
    this.headers = new HttpHeaders();
    this.headers.set("Content-Type", "application/json");
    this.headers.set("Access-Control-Allow-Origin", "*");
    this.headers.set("Access-Control-Allow-Methods", "PUT, GET, POST");
    this.headers.set(
      "Access-Control-Allow-Headers",
      "Origin, X-Requested-With, Content-Type, Accept"
    );
  }





}
